import { Component, inject, Input, OnChanges, OnDestroy } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ContractConfirmationFacade } from '@zero/shared/feature-contract-confirmation/base';
import { MicarContractsNudgingComponent } from '@zero/shared/feature-contract-confirmation/web';
import { InstrumentType, OrderDirection } from '@zero/shared/util-models';
import { TradeCreateHintBase } from '@zero/trade/feature-trade/base';
import { DEFAULT_TRADING_HOURS_START_TIME, DEFAULT_TRADING_HOURS_STOP_TIME } from 'constants/shared-constants';
import { CheckExperienceAndFtgComponent } from '../check-experience-and-ftg/check-experience-and-ftg.component';

@Component({
  selector: 'trade-create-hint',
  templateUrl: './trade-create-hint.component.html',
  imports: [CheckExperienceAndFtgComponent, TranslocoPipe, MicarContractsNudgingComponent],
})
export class TradeCreateHintComponent extends TradeCreateHintBase implements OnChanges, OnDestroy {
  @Input() public direction?: OrderDirection = 'buy';

  public readonly InstrumentType = InstrumentType;
  public readonly contractConfirmationFacade = inject(ContractConfirmationFacade);

  protected override setTradingHours(): void {
    if (!this.asset) {
      this.tradingHours = undefined;
      return;
    }

    const { tradingHoursStartTime, tradingHoursStopTime } = this.asset;
    if (tradingHoursStartTime && tradingHoursStopTime) {
      this.tradingHours = `${tradingHoursStartTime}-${tradingHoursStopTime}`;
    }
    this.hasSpecialTradingHours = !(
      tradingHoursStartTime === DEFAULT_TRADING_HOURS_START_TIME && tradingHoursStopTime === DEFAULT_TRADING_HOURS_STOP_TIME
    );

    if (this.asset.instrumentType === InstrumentType.Crypto) {
      this.hasSpecialTradingHours = false;
    }
  }
}
